/* ============================================================
   ENGRAVER'S LAB — theme behaviours layered on top of Dawn.
   Self-contained, no dependencies. Currently handles the
   Service-page flow toggle (Send your item / Buy & engrave).
   ============================================================ */
(function () {
  'use strict';

  function applyFlow(flow) {
    document.body.dataset.flow = flow;

    document.querySelectorAll('[data-flow]').forEach(function (btn) {
      var active = btn.dataset.flow === flow;
      btn.classList.toggle('is-active', active);
      btn.style.background = active ? 'var(--accent-tint)' : 'transparent';
      btn.style.borderColor = active ? 'var(--accent)' : 'transparent';
      btn.style.color = active ? 'var(--accent)' : 'var(--fg)';
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-flow-target]').forEach(function (section) {
      var target = section.dataset.flowTarget;
      section.hidden = !(target === 'any' || target === flow);
    });
  }

  // Click handler (delegated so it survives section re-renders in the editor)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-flow]');
    if (!btn) return;
    applyFlow(btn.dataset.flow);
  });

  function init() {
    var toggle = document.querySelector('[data-flow]');
    if (!toggle) return;
    // Respect ?mode=buy / ?flow=buy deep links, else the active button, else "send"
    var params = new URLSearchParams(window.location.search);
    var deep = params.get('flow') || params.get('mode');
    var initial =
      (deep === 'buy' || deep === 'send') ? deep :
      (document.querySelector('[data-flow].is-active') || { dataset: {} }).dataset.flow ||
      'send';
    applyFlow(initial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', init);

  /* ============================================================
     Mobile menu toggle — opens the primary nav on small screens.
     Delegated click survives section re-renders in the editor.
     ============================================================ */
  function closeMenu(header, btn) {
    if (!header) return;
    header.classList.remove('is-menu-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-menu-toggle]');
    if (btn) {
      var header = btn.closest('.site-header');
      if (!header) return;
      var isOpen = header.classList.toggle('is-menu-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
    // Close when clicking outside the open menu
    var openHeader = document.querySelector('.site-header.is-menu-open');
    if (openHeader && !e.target.closest('.site-header__nav') && !e.target.closest('[data-menu-toggle]')) {
      closeMenu(openHeader, openHeader.querySelector('[data-menu-toggle]'));
    }
  });

  // Close on Escape, and close after tapping a nav link
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openHeader = document.querySelector('.site-header.is-menu-open');
    closeMenu(openHeader, openHeader && openHeader.querySelector('[data-menu-toggle]'));
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.site-header__nav a');
    if (!link) return;
    var header = link.closest('.site-header');
    closeMenu(header, header && header.querySelector('[data-menu-toggle]'));
  });

  /* ============================================================
     Image-engraving toolbar — collapsible on mobile.
     The tool strip (crop/monochrome/reset/remove) can crowd the small
     screen, so a toggle button expands/collapses it. Delegated click.
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-epm-tools-toggle]');
    if (!btn) return;
    var tools = btn.closest('.epm-tools');
    if (!tools) return;
    var open = tools.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
